import constants from './constants';
import { IOSGIConfig } from '../interfaces';

export const abandonFormNotification = (config: IOSGIConfig['shellConfig']) => {
	config.abandonFormNotification &&
		window.addEventListener(constants.EVENT_WINDOW_BEFORE_UNLOAD, (event) => {
			event.preventDefault();
		});
};
